import { AlertaProps } from "@/types";

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  error?: string | boolean | AlertaProps;
}

export function TextareaComun({ className, value, onChange, error, rows = 6, cols = 10, placeholder = "Escribe tu mensaje aquí...", id = "", ...props }: Props) {
  const textareaClass = `border border-zinc-700 p-2 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400 w-full scrollbar-custom dark:border-gray-300 dark:bg-white dark:text-zinc-600 ${
    error ? "bg-red-100" : ""
  } ${className}`;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div>
      <textarea
        className={textareaClass}
        value={value}
        onChange={handleChange}
        rows={rows}
        cols={cols}
        placeholder={placeholder}
        id={id}
        {...props}
      />
    </div>
  );
}

export default TextareaComun;
